var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"autocomplete":"","items":_vm.statuses,"hide-details":"","placeholder":"Kies een status"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }